import React, { Component } from 'react';
import { get } from "lodash"
import aes from 'crypto-js/aes';
import { sexData } from "../sex/static.sexData"
import { resultData } from "../result/static.resultData"

import { withResultPage } from "../../../shared/containers/containerResultPage"
import getParameterFromURL from "./../../../utils/getParameterFromUrl"

import ImageResultBlock from "./imageResultBlock"
import ImageResultBlockWithTransform from "./imageResultBlockWithTransform"
import GraficResultBlock from "./graficResultBlock"
import BmiResultBlock from "./bmiResultBlock"
import CaloriesResultBlock from "./caloriesResultBlock"
import WaterResultBlock from "./waterResultBlock"
import WhatGetResultBlock from "./whatGetResultBlock"
import SuccessResultBlock from "./successResultBlock"
import ReviewsResultBlock from "./reviewsResultBlock"
import locales from "./../../../content.json"
import ReachYourWeight from './reachYourWeightPage/reachYourWeight'

import variables from "./../../../assets/styles/values.scss"
import styles from "./resultPage.module.scss"

import icon from "./img/icon.svg"
import stars from "./img/stars.svg"

let isWithMail = (getParameterFromURL("withMail") === "true");
let emailSetting = (getParameterFromURL("emailSetting") === "1");
let withTransformationImages = (getParameterFromURL("withTransformationImages") === "true");
let withTransformationImagesInStripe = (getParameterFromURL("withTransformationImagesInStripe") === "true");
let isDesignWithNewPaymentV1 = (getParameterFromURL("isDesignWithNewPaymentV1") === "true");
let withNewSubscriptions = (getParameterFromURL("withNewSubscriptions") === "true");
let newFirstScreenNumber1 = (getParameterFromURL("newFirstScreen") === "1");
let newFirstScreenNumber2 = (getParameterFromURL("newFirstScreen") === "2");
let mostPopular1MonthPrice = (getParameterFromURL("mostPopular1MonthPrice") === "true");
let disableAnimateButton = (getParameterFromURL("animateButton") === "false");
let disableShowPaymentByClick = (getParameterFromURL("showPaymentByClick") === "false");
let trialMonth = (getParameterFromURL("trialMonth") === "true");
let multiPricesV2 = (getParameterFromURL("multiPricesV2") === "true");
let parcelOffer = (getParameterFromURL("parcelOffer") === "true");
let reachYourWeight = (getParameterFromURL("reachYourWeight") === "true");
let multiPricesV4 = (getParameterFromURL("multiPricesV4") === "true");
let multiPricesV5 = (getParameterFromURL("multiPricesV5") === "true");
let multiPricesV6 = (getParameterFromURL("multiPricesV6") === "true");
let multiPricesV7 = (getParameterFromURL("multiPricesV7") === "true");
let multiPricesV8 = (getParameterFromURL("multiPricesV8") === "true");
let multiPricesV9 = (getParameterFromURL("multiPricesV9") === "true");
let multiPricesV10 = (getParameterFromURL("multiPricesV10") === "true");
let multiPricesV11 = (getParameterFromURL("multiPricesV11") === "true");
let pricesRangeV0 = (getParameterFromURL("pricesRangeV0") === "true");
let pricesRangeV1 = (getParameterFromURL("pricesRangeV1") === "true");
let pricesRangeV2 = (getParameterFromURL("pricesRangeV2") === "true");
let longPayV0 = (getParameterFromURL("longPayV0") === "true");
let longPayV1 = (getParameterFromURL("longPayV1") === "true");
let longPayV2 = (getParameterFromURL("longPayV2") === "true");
let longPayV3 = (getParameterFromURL("longPayV3") === "true");
let one_tariff_trial_V1 = (getParameterFromURL("one_tariff_trial_V1") === "true");
let one_tariff_trial_V2 = (getParameterFromURL("one_tariff_trial_V2") === "true");
let moneyBack = (getParameterFromURL("moneyBack") === "true");
let organicPricesV0 = (getParameterFromURL("organicPricesV0") === "true");
let organicPricesV1 = (getParameterFromURL("organicPricesV1") === "true");
let organicPricesV2 = (getParameterFromURL("organicPricesV2") === "true");
let organicPricesV3 = (getParameterFromURL("organicPricesV3") === "true");
let organicPricesV4 = (getParameterFromURL("organicPricesV4") === "true");
let pricesMusclesV0 = (getParameterFromURL("pricesMusclesV0") === "true");
let pricesRowV0 = (getParameterFromURL("pricesRowV0") === "true");
let pricesRowV1 = (getParameterFromURL("pricesRowV1") === "true");
let utTariffsOnly = (getParameterFromURL("utTariffsOnly") === "true");
let utTariffsUp = (getParameterFromURL("utTariffsUp") === "true");
let utWithoutTimer = (getParameterFromURL("utWithoutTimer") === "true");

let newFirstScreenNumber;

if (newFirstScreenNumber1) {
  newFirstScreenNumber = '1';
} else if (newFirstScreenNumber2) {
  newFirstScreenNumber = '2';
} else {
  newFirstScreenNumber = false;
}

var timeUnixNow = Date.now();

class ResultPage extends Component {
  constructor() {
    super();

    this.state = {
      isOpenResultPage: false,
      linkFromOnboarding: '',
    }
  }

  getParameterFromURL(name, url) {
    if (!url) url = window.location.href;

    name = name.replace(/[\[\]]/g, '\\$&');

    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
  
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  setFbp() {
    let fbpTime = +new Date;
    let fbpRandomNumbers = Math.floor(Math.random() * 10000000000);
    return `fb.1.${fbpTime}.${fbpRandomNumbers}`;
  }

  generateOneLink(data) {
    this.setState({
      linkFromOnboarding: data.data.onelink,
    });
  }

  componentDidUpdate(prevProps) {
    const { openResultPage } = this.props
    const { isOpenResultPage } = this.state
    var timeOut

    if (!openResultPage && prevProps.openResultPage) {
      clearInterval(timeOut)
      timeOut = setTimeout(function () {
        if (isOpenResultPage)
          this.setState({
            isOpenResultPage: false,
          })
      }.bind(this), variables.animateSteps)
    }

    let withPaypal = false;

    if (this.getParameterFromURL('withPaypal') === 'true') {
      withPaypal = true;
    }

    if (openResultPage && !prevProps.openResultPage) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'funnel on onboarding',
        'quiz_action': 'view results page'
      });

      clearInterval(timeOut)
      this.setState({
        isOpenResultPage: true,
      })

      let pidValue;

      if (this.getParameterFromURL('af_pid')) {
        pidValue = this.getParameterFromURL('af_pid');
      } else if (this.getParameterFromURL('utm_source')) {
        pidValue = this.getParameterFromURL('utm_source');
      }

      if (pidValue === '') {
        pidValue = document.referrer;
      }

      let campaignValue = null;

      if (this.getParameterFromURL('af_c')) {
          campaignValue = this.getParameterFromURL('af_c');
      } else if (this.getParameterFromURL('utm_campaign')) {
          campaignValue = this.getParameterFromURL('utm_campaign');
      }

      let key;

      if (this.getParameterFromURL('withStripe') === 'true') {
        key = 'verv-paid-web-onboarding'
      } else {
        key = 'verv-free-web-onboarding'
      }

      if (campaignValue === null) {
        if (this.getParameterFromURL('withStripe') === 'true') {
          campaignValue = 'paid-web-onboarding'
        } else {
          campaignValue = 'free-web-onboarding'
        }
      }

      let fbp = this.readCookie('_fbp');

      let fbclidValue = this.getParameterFromURL('fbclid');

      let fbcFinal = null;
  
      if (fbclidValue) fbcFinal = `fb.1.${timeUnixNow}.${fbclidValue}`;

      let fbc = this.readCookie('_fbc') ? this.readCookie('_fbc') : fbcFinal;

      let af_prt = this.getParameterFromURL('af_prt');
      let af_adset = this.getParameterFromURL('utm_term');
      let af_ad = this.getParameterFromURL('utm_content');

      let onelink_params = {
        pid: pidValue,
        c: campaignValue,
        landingType: 'free-web-onboarding',
        ...(af_prt) && {af_prt: af_prt},
        ...(af_adset) && {af_adset: af_adset},
        ...(af_ad) && {af_ad: af_ad},
        deep_link_value: 'free-web-onboarding',
      };

      let dataToSend = {
        'bundle_id': 'com.verv.app',
        ...(isWithMail) && {email: this.props.data.mail.value},
        'extra_data': {
          'campaign_name': campaignValue,
          'pid': pidValue,
          'gender': this.props.data.sex.value,
          'language': window.navigator.language,
          'source_key': key,
          'source_url': window.location.href,
          ...(fbp) && {fbp: fbp},
        },
        'onelink_query_params': onelink_params,
        ...(fbc) && {fbclickid: fbc},
      };

      if (this.getParameterFromURL('withStripe') !== 'true') {
        fetch(`${process.env.REACT_APP_API_URL}/v4/web_extra_data`, {method: "POST",
          body: JSON.stringify(dataToSend)
            }).then((response) => {
              return response.json();
        })
        .then((data) => {
            this.generateOneLink(data);
        })
      }

      if (this.getParameterFromURL('withStripe') === 'true') {
        let fbclidValue = this.getParameterFromURL('fbclid');

        if (campaignValue === null) {
          campaignValue = 'paid-web-onboarding';
        }
  
        let fbcFinal = null;
  
        if (fbclidValue) fbcFinal = `fb.1.${timeUnixNow}.${fbclidValue}`;
  
        let fbc = this.readCookie('_fbc') ? this.readCookie('_fbc') : fbcFinal;

        let isWithTrial = this.getParameterFromURL('withTrial') === 'true';

        let isBeforeAfterDesign = this.getParameterFromURL('beforeAfterDesign') === 'true';
        let isSpecialOfferV2 = getParameterFromURL('specialOfferV2') === 'true';
        let showAppFeatures = getParameterFromURL('showAppFeatures');
        let hidePlan = getParameterFromURL('hidePlan');
        let showSpecialOfferOnInitScreenV2 = getParameterFromURL('showSpecialOfferOnInitScreenV2');
        let newPaymentPage = getParameterFromURL('newPaymentPage');
        let productOnInitScreen = getParameterFromURL('productOnInitScreen');
        let oldPriceOnInitScreen = getParameterFromURL('oldPriceOnInitScreen');
        let data = this.props.data;
        let emailValue = this.props.data.mail ? this.props.data.mail.value : false;

        if (emailValue) {
          emailValue = aes.encrypt(emailValue, '9213812384').toString();
        }
        
        let goal = get(data, ["sex", "value"]) === sexData.male.value
        ? get(data, ["result", "value"]) === resultData.male.lose.value
          ? "Your Customized Weight Loss Plan is Ready!"
          : get(data, ["result", "value"]) === resultData.male.muscle.value
            ? "Your Customized Muscle Gain Plan is Ready!"
            : "Your Customized Fitness Plan is Ready!"
        : get(data, ["sex", "value"]) === sexData.female.value
          ? get(data, ["result", "value"]) === resultData.female.lose.value
            ? "Your Customized Weight Loss Plan is Ready!"
            : get(data, ["result", "value"]) === resultData.female.tone.value
              ? "Your Customized Fitness Plan is Ready!"
              : get(data, ["result", "value"]) === resultData.female.love.value
                ? "Your Customized Fitness Plan is Ready!"
                : "Your Customized Fitness Plan is Ready!"
          : get(data, ["sex", "value"]) === sexData.other.value
            ? "Your Customized Weight Loss Plan is Ready!"
            : get(data, ["result", "value"]) === resultData.other.tone.value
              ? "Your Customized Fitness Plan is Ready!"
              : get(data, ["result", "value"]) === resultData.other.love.value
                ? "Your Customized Fitness Plan is Ready!"
                : "Your Customized Fitness Plan is Ready!";

        let currentHostnameHealth = window.location.hostname === 'verv.health';
        let currentHostnameHealthDev = window.location.hostname === 'dev-health.verv.com';
        let url = process.env.REACT_APP_LINK_TO_STRIPE;

        if (currentHostnameHealth) url = 'https://verv.health/pay';
        if (currentHostnameHealthDev) url = 'https://dev-health.verv.com/pay';
  
        let link = `${url}/?` +
          `fbc=${fbc}&` +
          `gender=${this.props.data.sex.value}&` +
          `goal=${goal}&` +
          `withPaypal=${withPaypal}&` +
          `withTrial=${isWithTrial}&` +
          `c=${campaignValue}&` +
          `beforeAfterDesign=${isBeforeAfterDesign}&` +
          `source=paid-web-onboarding&` +
          `pid=${pidValue}&` +
          `withTransformationImagesInStripe=${withTransformationImagesInStripe}&` +
          `specialOfferV2=${isSpecialOfferV2}&` +
          `isDesignWithNewPaymentV1=${isDesignWithNewPaymentV1}&` +
          `withNewSubscriptions=${withNewSubscriptions}&` +
          `newFirstScreen=${newFirstScreenNumber}&` +
          `showAppFeatures=${showAppFeatures}&` +
          `showSpecialOfferOnInitScreenV2=${showSpecialOfferOnInitScreenV2}&` +
          `newPaymentPage=${newPaymentPage}&` +
          `mostPopular1MonthPrice=${mostPopular1MonthPrice}&` +
          `hidePlan=${hidePlan}`;

        
        if (productOnInitScreen) {
          link += `&productOnInitScreen=${productOnInitScreen}`;
        }
        
        if (oldPriceOnInitScreen) {
          link += `&oldPriceOnInitScreen=${oldPriceOnInitScreen}`;
        }

        if (af_prt != null) link += `&af_prt=${af_prt}`;
        if (af_adset != null) link += `&utm_term=${af_adset}`;
        if (af_ad != null) link += `&utm_content=${af_ad}`;
        if (disableAnimateButton) link += `&animateButton=false`;
        if (disableShowPaymentByClick) link += `&showPaymentByClick=false`;
        if (trialMonth) link += `&trialMonth=${trialMonth}`;
        if (isWithMail && emailValue) link += `&ev=${emailValue}`;
        if (emailSetting) link += `&emailSetting=1`;
        if (fbp) link += `&fbp=${fbp}`;
        if (multiPricesV2) link += `&multiPricesV2=true`;
        if (parcelOffer) link += `&parcelOffer=true`;
        if (reachYourWeight) link += `&reachYourWeight=true`;
        if (multiPricesV4) link += `&multiPricesV4=true`;
        if (multiPricesV5) link += `&multiPricesV5=true`;
        if (multiPricesV6) link += `&multiPricesV6=true`;
        if (multiPricesV7) link += `&multiPricesV7=true`;
        if (multiPricesV8) link += `&multiPricesV8=true`;
        if (multiPricesV9) link += `&multiPricesV9=true`;
        if (multiPricesV10) link += `&multiPricesV10=true`;
        if (multiPricesV11) link += `&multiPricesV11=true`;
        if (pricesRangeV0) link += `&pricesRangeV0=true`;
        if (pricesRangeV1) link += `&pricesRangeV1=true`;
        if (pricesRangeV2) link += `&pricesRangeV2=true`;
        if (longPayV0) link += `&longPayV0=true`;
        if (longPayV1) link += `&longPayV1=true`;
        if (longPayV2) link += `&longPayV2=true`;
        if (longPayV3) link += `&longPayV3=true`;
        if (one_tariff_trial_V1) link += `&one_tariff_trial_V1=true`;
        if (one_tariff_trial_V2) link += `&one_tariff_trial_V2=true`;
        if (moneyBack) link += `&moneyBack=true`;
        if (organicPricesV0) link += `&organicPricesV0=true`;
        if (organicPricesV1) link += `&organicPricesV1=true`;
        if (organicPricesV2) link += `&organicPricesV2=true`;
        if (organicPricesV3) link += `&organicPricesV3=true`;
        if (organicPricesV4) link += `&organicPricesV4=true`;
        if (pricesMusclesV0) link += `&pricesMusclesV0=true`;
        if (pricesRowV0) link += `&pricesRowV0=true`;
        if (pricesRowV1) link += `&pricesRowV1=true`;
        if (utTariffsOnly) link += `&utTariffsOnly=true`;
        if (utTariffsUp) link += `&utTariffsUp=true`;
        if (utWithoutTimer) link += `&utWithoutTimer=true`;
  
        this.setState({
          linkFromOnboarding: link,
        });
      }
    }
  }

  render() {
    const { isOpenResultPage } = this.state
    const { data } = this.props

    return isOpenResultPage ?

      <div className={styles.resultPage}>

        {reachYourWeight && 
          <div className={styles.container_weightLoss}>
            <ReachYourWeight data={data} />
            <a className={styles.link_rectangle_button} href={this.state.linkFromOnboarding} target="_blank">
              <div className={styles.rectangle_button}>{locales[window.userLang].get_my_plan}</div>
            </a>
          </div>}

        {!reachYourWeight && withTransformationImages && (
          <ImageResultBlockWithTransform data={data} link={this.state.linkFromOnboarding} />
        )}

        {!reachYourWeight && !withTransformationImages && (
          <ImageResultBlock data={data} link={this.state.linkFromOnboarding} />
        )}

        {!reachYourWeight && <div className={styles.resultPageWrapper}>
          <GraficResultBlock data={data} />

          <div className={styles.container_bmi}>
            <BmiResultBlock data={data} />
          </div>

          <div className={styles.container_calories}>
            <CaloriesResultBlock data={data} />
          </div>

          <div className={styles.container_waters}>
            <WaterResultBlock data={data} />
          </div>

          <div className={styles.container_whatGet}>
            <WhatGetResultBlock />
          </div>

          <div className={styles.container_successStory}>
            <SuccessResultBlock data={data} />
          </div>

          <div className={styles.container_reviews}>
            <ReviewsResultBlock />
          </div>

          <a className={styles.linkRounded} href={this.state.linkFromOnboarding} target="_blank">
            <div className={styles.pseudoButton}>{locales[window.userLang].get_my_plan}</div>
          </a>
          </div>}
      </div>
      : null
  }
}

export default withResultPage(ResultPage);